import { useMemo, useEffect, useState } from 'react'
import { Country } from 'country-state-city'
import { ICountry } from 'country-state-city/lib/interface'

import { ENDPOINTS } from '../../utils/constants/endpoints'
import { useLocalState } from '../local-storage'

/**
 * useIpCountry
 * @description custom hook to get users country based on their IP
 */
export const useIpCountry = () => {
    const [state, setState] = useLocalState<ICountry | undefined>(
        'country-code'
    )
    const [loading, setLoading] = useState(false)
    const countries: ICountry[] = useMemo(() => Country.getAllCountries(), [])

    useEffect(() => {
        const controller = new AbortController()
        if (!state) {
            setLoading(true)
            fetch(ENDPOINTS.IP_INFO, {
                method: 'GET',
                signal: controller.signal,
            })
                .then((response) => response.json())
                .then((response) =>
                    setState(
                        countries.find(
                            (country) =>
                                country.isoCode.toLowerCase() ===
                                response.country.toLowerCase()
                        )
                    )
                )
                .finally(() => setLoading(false))
        }

        return () => {
            controller.abort()
        }
    }, [state, setState, countries])

    return [state, setState, countries, loading] as const
}
